// extracted by mini-css-extract-plugin
module.exports = {"card":"NewSubtaskInput_card__PcSNx","activeCard":"NewSubtaskInput_activeCard__7P0tE"};